import { Component, Input, input, OnInit } from "@angular/core";
import { NgOptimizedImage } from "@angular/common";

type MlsLogoObj = {
    src: string;
    width: number;
    height: number;
    styleWidth: string;
};

@Component({
    selector: "hs-icon",
    imports: [NgOptimizedImage],
    templateUrl: "./icon.component.html",
    styleUrl: "./icon.component.sass",
    standalone: true,
})
export class IconComponent implements OnInit {
    src = input.required<string>();
    height = input.required<number>();
    width = input.required<number>();
    @Input()
    alt: string = "";

    ngOnInit(): void {}
}
